export default "__VITE_ASSET__CjuciWtS__"